/* eslint-disable react/react-in-jsx-scope */
import { put } from 'helpers/api_helper';

const ModalEditCompanyStatus = ({companySelected, setIsModalOpen, setCurrentPage, 
urlTo }) => {
    
  const handleEditCompany = async () => {
    const url = `${process.env.REACT_APP_API_INT_LEADS}/api/empresas-${urlTo}/${companySelected.Id}`;
    companySelected.Status = companySelected.Status === true ? false : true;
    
    try {
      await put(url, companySelected);
      setCurrentPage(1);
      setIsModalOpen(false);
      return;
    } catch (error) {
      if(error.response?.status === 400) {
        alert(error.response.data.message);
        return;
      } else {
        alert("Algo de errado aconteceu! Tente mais tarde ou verifique sua internet");
        return;
      }
    }
  }

  return (
    <div className='companys-modal-container '>
      <div className='modal-inner-container'>
        <span className='span-title-atention'>ATENÇÃO</span>
        {companySelected.Status === true && (
          <span className='span-company-text'>
            Você tem certeza que deseja<br/> 
            inativar esta empresa?
          </span>
        )}
        {companySelected.Status === false && (
          <span className='span-company-text'>
            Você tem certeza que deseja<br/> 
            ativar esta empresa?
          </span>
        )}
        <div className='buttons-actions-row'>
          <button 
            className='btn btn-primary w-md button-company-modal'
            onClick={() => setIsModalOpen(false)}
            type='button'
          >
            Cancelar
          </button>
          <button 
            type='button'
            className='btn btn-primary w-md button-company-modal'
            onClick={handleEditCompany}
          >
            Confirmar
          </button>
        </div>
      </div>
    </div>
  )
}

export default ModalEditCompanyStatus